import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Form from 'react-bootstrap/Form';

import { FaCalendarAlt } from "react-icons/fa";
import { API } from 'aws-amplify';
import Graph from '../../components/Graph';
import { getChartColors } from '../../theme/palette';
import { useDisplayMode } from '../../theme/displayMode';
import '../../components/PageHeader/PageHeader.css';
import PageHeader from '../../components/PageHeader/PageHeader';
import { useI18n } from '../../i18n';

import "./KPIs.css";

function sumField(list, key) {
  return (list || []).reduce((sum, item) => sum + Number(item[key] || 0), 0);
}

function pct(part, whole) {
  const total = Number(whole);
  if (!total) return null;
  return Math.round((Number(part) / total) * 1000) / 10;
}

function formatPct(value) {
  return value === null || value === undefined ? '—' : `${value}%`;
}

function formatEuro(value, compact) {
  const n = Number(value) || 0;
  if (compact && n >= 1000) return `€${(n / 1000).toFixed(1)}k`;
  return `€${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

function slaTone(rate) {
  if (rate === null || rate === undefined) return 'neutral';
  if (rate >= 90) return 'good';
  if (rate >= 75) return 'warn';
  return 'bad';
}

function KpiStat({ label, value, hint, tone }) {
  return (
    <div className={`kpi-stat is-${tone || 'neutral'}`}>
      <span className="kpi-stat-label">{label}</span>
      <strong className="kpi-stat-value">{value}</strong>
      {hint ? <span className="kpi-stat-hint">{hint}</span> : null}
    </div>
  );
}

const KPIs = (props) => {
    const { t, tCatalog, language } = useI18n();
    const { theme } = useDisplayMode();
    const chartColors = getChartColors(theme);
    const axisColors = chartColors;
    const createdSeries = {
      backgroundColor: chartColors.active,
      hoverBackgroundColor: chartColors.activeHover,
      borderColor: chartColors.activeBorder,
      borderWidth: 1,
    };
    const completedSeries = {
      backgroundColor: chartColors.completed,
      hoverBackgroundColor: chartColors.completedHover,
      borderColor: chartColors.completedBorder,
      borderWidth: 1,
    };
    const slaOkSeries = {
      backgroundColor: chartColors.success,
      hoverBackgroundColor: chartColors.successHover,
      borderWidth: 0,
    };
    const slaFailSeries = {
      backgroundColor: chartColors.danger,
      hoverBackgroundColor: chartColors.dangerHover,
      borderWidth: 0,
    };
    const [serviceCall, setServiceCall] = useState({});
    const [servCallTbl, setServCallTbl] = useState([]);
    const [spendData, setSpendData] = useState({});
    const [reactiveData, setReactiveData] = useState({});
    const [reactiveTbl, setReactiveTbl] = useState([]);
    const [ppmData, setPpmData] = useState({});
    const [ppmTbl, setPpmTbl] = useState([]);
    const [slaAttendanceData, setSlaAttendanceData] = useState({});
    const [slaAttendanceTbl, setSlaAttendanceTbl] = useState([]);
    const [slaRepairData, setSlaRepairData] = useState({});
    const [slaRepairTbl, setSlaRepairTbl] = useState([]);

    const [tasks, setTasks] = useState([]);
    const [tasksCosts, setTasksCosts] = useState([]);
    const [dataCosts, setDataCosts] = useState([]);
    const [totalCosts, setTotalCosts] = useState(0);

    const [month, setMonth] = useState(() => new Date().getMonth() +1)
    const [year, setYear] = useState(() => new Date().getFullYear())

    const today = new Date();

    const months = [
        t('months.january'), t('months.february'), t('months.march'), t('months.april'),
        t('months.may'), t('months.june'), t('months.july'), t('months.august'),
        t('months.september'), t('months.october'), t('months.november'), t('months.december')
    ];
    
    const years = []

    for (var i = today.getFullYear(); i >= today.getFullYear()-5; i--) years.push(i)
    
    const params = { 
        headers: {
        'x-api-key': process.env.REACT_APP_API_KEY
        },
      }


    // Load tasks for side board, graphs and map
    useEffect(()=>{

    let mm = 1
    if (month>9) {mm = month} else {mm = '0'+ month}

    let date_from = new Date(year +'-'+ mm +'-01')
  
    const fetchTasks = async () => {

    const taskListFiltered = [];
    const taskList = await API.get('task_by_month','/' + date_from.toISOString(), params)
    
 
    for (let i = 0; i < taskList.length; i++) {

    let month_comp = 0
    let month_cre = 0
    if (taskList[i].date_completed){
    const d = new Date(taskList[i].date_completed);    
    month_comp = d.getMonth()+1
    }
    if (taskList[i].date_created){
        const d = new Date(taskList[i].date_created);  
        month_cre = d.getMonth()+1
    }     
    
    taskList[i].month_cre = month_cre;
    taskList[i].month_comp = month_comp;


    if (taskList[i].date_created && taskList[i].date_started){
      const date_create = new Date(taskList[i].date_created); 
      const date_start = new Date(taskList[i].date_started); 
      const diff = new Date(date_start - date_create);
      taskList[i].sla_attend_compliance = diff.getUTCHours();
    }

    if (taskList[i].date_completed && taskList[i].date_started){
      const date_complete = new Date(taskList[i].date_completed); 
      const date_start = new Date(taskList[i].date_started); 
      const diff = new Date(date_complete - date_start);
      taskList[i].sla_repair_compliance = diff.getUTCHours();

    }
    
    // graph shows the last 30 days
    if (month_comp === month || month_cre === month){          
      taskListFiltered.push(taskList[i]);
    }

  }   

  setTasks(taskListFiltered);

}

  fetchTasks();	

}, [month, year]);    

// Load tasks costs
useEffect(()=>{
    const fetchTasks = async () => {
    const taskList = await API.get('task_annual_costs','/' + year, params)
    setTasksCosts(taskList);
}
fetchTasks();	

}, [year]);

  const countBy = (match) => tasks.filter(match).length;

  const buildCallSets = (labels, matchers) => {
    const created = {};
    const completed = {};
    const pending = {};
    labels.forEach((key, i) => {
      const isCat = matchers[i];
      created[key] = countBy((item) => isCat(item) && item.month_cre === month);
      completed[key] = countBy((item) => isCat(item) && item.month_comp === month);
      pending[key] = countBy((item) => isCat(item) && item.month_cre === month && !item.date_completed);
    });
    return { created, completed, pending };
  };

  // Fault Category Graph
  const getFault_Category = () => {
    const labels = ["Reactive", "PPM", "Switch off/on", "Upgrade", "Signs", "Other"];
    const matchers = [
      (item) => item.category === 'Reactive',
      (item) => item.category === 'PPM',
      (item) => item.category === 'Switch off / on',
      (item) => item.category === 'Upgrade',
      (item) => item.category === 'Signs',
      (item) => item.category === 'Other',
    ];
    const { created, completed, pending } = buildCallSets(labels, matchers);

    const data = {
      labels: labels.map(tCatalog),
      datasets: [
        { label: t('kpis.created'), ...createdSeries, data: labels.map((key) => created[key]) },
        { label: t('kpis.done'), ...completedSeries, data: labels.map((key) => completed[key]) },
      ],
    };

    const list = labels.map((key) => ({
      key,
      created: created[key],
      completed: completed[key],
      pending: pending[key],
    }));

    setServiceCall(data);
    setServCallTbl(list);
  };

  // Reactive tasks
  const getReactive_Category = () => {
    const labels = ["Controller Fault", "Detector Fault", "PBU Fault", "Electrical Fault", "Lamp Fault", "Comms Fault", "Sign Fault", "Knockdown", "Other"];
    const matchers = labels.map((type) => (item) => item.category === 'Reactive' && item.type_fault === type);
    const { created, completed, pending } = buildCallSets(labels, matchers);
    const list = labels
      .map((key) => ({
        key,
        created: created[key],
        completed: completed[key],
        pending: pending[key],
        volume: created[key] + completed[key] + pending[key],
      }))
      .filter((row) => row.volume > 0)
      .sort((a, b) => b.volume - a.volume);
    const chartLabels = list.map((row) => tCatalog(row.key));

    const data = {
      labels: chartLabels,
      datasets: [
        { label: t('kpis.created'), ...createdSeries, data: list.map((row) => row.created) },
        { label: t('kpis.done'), ...completedSeries, data: list.map((row) => row.completed) },
      ],
    };

    setReactiveData(data);
    setReactiveTbl(list);
  };

  // PPM Tasks
  const getPPM_Category = () => {
    const pairs = [
      ['Periodic Insp', 'Periodic Inspection'],
      ['Annual Insp (Sig)', 'Annual Inspection (Signals)'],
      ['Annual Insp (Struc)', 'Annual Inspection (Structures)'],
      ['Annual Insp (Signs)', 'Annual Inspection (Signs)'],
      ['Routine Maint', 'Routine Maintenance'],
      ['Non LED Lamp rep', 'Non LED Lamp replacement'],
    ];
    const labels = pairs.map((pair) => pair[0]);
    const matchers = pairs.map((pair) => (item) => item.category === 'PPM' && item.type_fault === pair[1]);
    const { created, completed, pending } = buildCallSets(labels, matchers);
    const list = labels.map((key) => ({
      key,
      created: created[key],
      completed: completed[key],
      pending: pending[key],
    }));

    const data = {
      labels: labels.map(tCatalog),
      datasets: [
        { label: t('kpis.created'), ...createdSeries, data: labels.map((key) => created[key]) },
        { label: t('kpis.done'), ...completedSeries, data: labels.map((key) => completed[key]) },
      ],
    };

    setPpmData(data);
    setPpmTbl(list);
  };

  // Annual Spend
  const getAnnualSpend = async () => {

    let prelim = 0

    // get prelim costs of the year
    await API.get('costs','/', params)
    .then(res => {        
      prelim = res.filter(item => {return new Date(item.date).getFullYear() === year }).reduce((sum, item) => {return sum = sum + parseFloat(item.cost) }, 0)      
    });
    
    //Total costs is  Prelim + Total Cost  
    const totalCosts = tasksCosts.filter(item => {return item.total_cost}).reduce((sum, item) => {return sum = sum + parseFloat(item.total_cost) }, 0)
 
    const cost = {
      "Preliminaries": prelim, 
      "Reactive": tasksCosts.filter(item => {return item.category === 'Reactive' && item.total_cost}).reduce((sum, item) => {return sum = sum + parseFloat(item.total_cost) }, 0), 
      "PPM": tasksCosts.filter(item => {return item.category === 'PPM' && item.total_cost}).reduce((sum, item) => {return sum = sum + parseFloat(item.total_cost) }, 0), 
      "Non-LED Lamp": tasksCosts.filter(item => {return item.category === 'PPM' && item.type_fault === 'Non LED Lamp replacement' && item.total_cost})
                                      .reduce((sum, item) => {return sum = sum + parseFloat(item.total_cost) }, 0), 
      "Materials": tasksCosts.filter(item => {return item.materials}).reduce((sum, item) => {return sum = sum + parseFloat(item.materials) }, 0),
      "Upgrades": tasksCosts.filter(item => {return item.category === 'Upgrade' && item.total_cost}).reduce((sum, item) => {return sum = sum + parseFloat(item.total_cost) }, 0),
      "Other": tasksCosts.filter(item => {return item.category === 'Other' && item.total_cost}).reduce((sum, item) => {return sum = sum + parseFloat(item.total_cost) }, 0),
    }

    const filteredCost = Object.keys(cost);

    const data = {
      labels: filteredCost.map(tCatalog),
      datasets: [
        {
        label: 'Costs',
        backgroundColor: chartColors.spend,
        hoverBackgroundColor: chartColors.spendHover,
        borderColor: chartColors.sliceBorder,
        borderWidth: 2,
        data: filteredCost.map(key => cost[key]),
        },
      ],
    };

    const arrLegend = [];
    const legend = Object.entries(cost);
    legend.forEach(([key, value],i) => {
      arrLegend.push({key, value, color: chartColors.spend[i] || chartColors.primary})
    })


    setSpendData(data);
    setDataCosts(arrLegend)
    setTotalCosts(() => totalCosts + prelim);
  };

  // SLA Attendance Compliance
  const getSLA_Attendance = () => {

    const sla_compliance = {
      "Reactive": tasks.filter(item => item.category === 'Reactive' && item.sla_attend_compliance <= item.sla_attend && item.month_comp === month).length,
      "PPM Inspections": tasks.filter(item => item.category === 'PPM' && 
                            (item.type_fault === 'Periodic Inspection' ||
                            item.type_fault === 'Annual Inspection (Signals)' || 
                            item.type_fault === 'Annual Inspection (Structures)' || 
                            item.type_fault === 'Annual Inspection (Signs)')
                            && (item.sla_attend_compliance <= item.sla_attend && item.sla_attend >= 0) && item.month_comp === month).length,
      "PPM Routine Maint": tasks.filter(item => item.category === 'PPM' && item.type_fault === 'Routine Maintenance' && item.sla_attend_compliance <= item.sla_attend && item.month_comp === month).length,
    }
    const sla_non_compliance = {
      "Reactive": tasks.filter(item => item.category === 'Reactive' && item.sla_attend_compliance > item.sla_attend && item.month_comp === month).length,
      "PPM Inspections": tasks.filter(item => item.category === 'PPM' &&
                            (item.type_fault === 'Periodic Inspection' ||
                            item.type_fault === 'Annual Inspection (Signals)' || 
                            item.type_fault === 'Annual Inspection (Structures)' || 
                            item.type_fault === 'Annual Inspection (Signs)')
                             && (item.sla_attend_compliance > item.sla_attend && item.sla_attend > 0) && item.month_comp === month).length,
      "PPM Routine Maint": tasks.filter(item => item.category === 'PPM' && item.type_fault === 'Routine Maintenance' && item.sla_attend_compliance > item.sla_attend && item.month_comp === month).length,
      }

    const filteredComp = Object.keys(sla_compliance); 
    const filteredNonComp = Object.keys(sla_non_compliance); 
    const data = {
      labels: filteredComp.map(tCatalog),
      datasets: [
        {
        label: t('kpis.onTime'),
        ...slaOkSeries,
        data: filteredComp.map(key => sla_compliance[key]),
        stack: '1'
        },
        {
          label: t('kpis.late'),
          ...slaFailSeries,
          data: filteredNonComp.map(key => sla_non_compliance[key]),
          stack: '1'
          },
      ],
    };
    const list = []
    filteredComp.forEach(key => {
        const compl = sla_compliance[key];
        const noncomp = sla_non_compliance[key];
        list.push({key, compl, noncomp, rate: pct(compl, compl + noncomp)} )
      })

    setSlaAttendanceData(data);
    setSlaAttendanceTbl(list);
  };

  // SLA Repair Compliance
  const getSLA_Repair = () => {

    const sla_compliance = {
      "Reactive": tasks.filter(item => item.category === 'Reactive' && item.sla_repair_compliance <= parseFloat(item.sla_repair) && item.month_comp === month).length,
      "PPM Inspections": tasks.filter(item => item.category === 'PPM' &&
                            (item.type_fault === 'Periodic Inspection' ||
                            item.type_fault === 'Annual Inspection (Signals)' || 
                            item.type_fault === 'Annual Inspection (Structures)' || 
                            item.type_fault === 'Annual Inspection (Signs)')
                            && (item.sla_repair_compliance <= parseFloat(item.sla_repair) && item.sla_repair >= 0) && item.month_comp === month).length,
      "PPM Routine Maint": tasks.filter(item => item.category === 'PPM' && item.type_fault === 'Routine Maintenance' && item.sla_repair_compliance <= parseFloat(item.sla_repair) && item.month_comp === month).length,
     }
    const sla_non_compliance = {
      "Reactive": tasks.filter(item => item.category === 'Reactive' && item.sla_repair_compliance > parseFloat(item.sla_repair) && item.month_comp === month).length,
      "PPM Inspections": tasks.filter(item => item.category === 'PPM' &&
                            (item.type_fault === 'Periodic Inspection' ||
                            item.type_fault === 'Annual Inspection (Signals)' || 
                            item.type_fault === 'Annual Inspection (Structures)' || 
                            item.type_fault === 'Annual Inspection (Signs)')
                            && (item.sla_repair_compliance > parseFloat(item.sla_repair) && item.sla_repair > 0) && item.month_comp === month).length,
      "PPM Routine Maint": tasks.filter(item => item.category === 'PPM' && item.type_fault === 'Routine Maintenance' && item.sla_repair_compliance > parseFloat(item.sla_repair) && item.month_comp === month).length,
     }

    const filteredComp = Object.keys(sla_compliance);
    const filteredNonComp = Object.keys(sla_non_compliance);
    const data = {
      labels: filteredComp.map(tCatalog),
      datasets: [
        {
        label: t('kpis.onTime'),
        ...slaOkSeries,
        data: filteredComp.map(key => sla_compliance[key]),
        stack: '1'
        },
        {
          label: t('kpis.late'),
          ...slaFailSeries,
          data: filteredNonComp.map(key => sla_non_compliance[key]),
          stack: '1'
          },
      ],
    };
    const list = []
    filteredComp.forEach(key => {
        const compl = sla_compliance[key];
        const noncomp = sla_non_compliance[key];
        list.push({key, compl, noncomp, rate: pct(compl, compl + noncomp)} )
      })

    setSlaRepairData(data);
    setSlaRepairTbl(list);
  };

  useEffect(() => {
        getFault_Category();
        getReactive_Category();
        getPPM_Category();
        getSLA_Attendance();
        getSLA_Repair();  
  },[tasks, theme, language]);

  useEffect(() => {
    getAnnualSpend();
},[tasksCosts, year, theme, language]);

const tooltipTheme = {
    mode: 'index',
    intersect: false,
    backgroundColor: axisColors.tooltipBg,
    titleFontColor: axisColors.tooltipColor,
    bodyFontColor: axisColors.tooltipColor,
};
const legendOpt = {
    display: true,
    position: 'bottom',
    labels: {
        boxWidth: 10,
        fontSize: 11,
        padding: 12,
        fontColor: axisColors.textSecondary,
    },
};
const barOptions = {
    maintainAspectRatio: false,
    defaultFontColor: axisColors.textSecondary,
    legend: legendOpt,
    tooltips: tooltipTheme,
    scales: {
        xAxes: [{ ticks: { autoSkip: true, maxRotation: 0, minRotation: 0, fontSize: 11, fontColor: axisColors.textSecondary }, gridLines: { display: false } }],
        yAxes: [{ ticks: { beginAtZero: true, precision: 0, fontColor: axisColors.textSecondary }, gridLines: { color: axisColors.grid, zeroLineColor: axisColors.gridZero } }],
    },
};
const horizOptions = {
    maintainAspectRatio: false,
    defaultFontColor: axisColors.textSecondary,
    legend: legendOpt,
    tooltips: tooltipTheme,
    scales: {
        xAxes: [{ ticks: { beginAtZero: true, precision: 0, fontColor: axisColors.textSecondary }, gridLines: { color: axisColors.grid, zeroLineColor: axisColors.gridZero } }],
        yAxes: [{ gridLines: { display: false }, ticks: { fontSize: 11, fontColor: axisColors.textSecondary } }],
    },
};
const slaHorizOptions = {
    maintainAspectRatio: false,
    defaultFontColor: axisColors.textSecondary,
    legend: legendOpt,
    tooltips: tooltipTheme,
    scales: {
        xAxes: [{ stacked: true, ticks: { beginAtZero: true, precision: 0, fontColor: axisColors.textSecondary }, gridLines: { color: axisColors.grid, zeroLineColor: axisColors.gridZero } }],
        yAxes: [{ stacked: true, gridLines: { display: false }, ticks: { fontSize: 11, fontColor: axisColors.textSecondary } }],
    },
};
const doughnutOptions = {
    maintainAspectRatio: false,
    defaultFontColor: axisColors.textSecondary,
    legend: { display: false },
    tooltips: {
      backgroundColor: axisColors.tooltipBg,
      titleFontColor: axisColors.tooltipColor,
      bodyFontColor: axisColors.tooltipColor,
      callbacks: {
        label: (tooltipItem, data) => {
          const label = data.labels[tooltipItem.index] || '';
          const value = data.datasets[0].data[tooltipItem.index] || 0;
          return ` ${label}: ${formatEuro(value)}`;
        },
      },
    },
};

const createdTotal = sumField(servCallTbl, 'created');
const completedTotal = sumField(servCallTbl, 'completed');
const pendingTotal = sumField(servCallTbl, 'pending');
const completionRate = pct(completedTotal, createdTotal);
const slaAttendOk = sumField(slaAttendanceTbl, 'compl');
const slaAttendLate = sumField(slaAttendanceTbl, 'noncomp');
const slaAttendRate = pct(slaAttendOk, slaAttendOk + slaAttendLate);
const slaRepairOk = sumField(slaRepairTbl, 'compl');
const slaRepairLate = sumField(slaRepairTbl, 'noncomp');
const slaRepairRate = pct(slaRepairOk, slaRepairOk + slaRepairLate);
const reactiveCreated = sumField(reactiveTbl, 'created');
const ppmCreated = sumField(ppmTbl, 'created');
const ppmCompleted = sumField(ppmTbl, 'completed');
const ppmPending = sumField(ppmTbl, 'pending');

return (
     
    <div className="KPIs">
      <PageHeader
        title={t('pages.kpis.title')}
        subtitle={t('pages.kpis.subtitle')}
        breadcrumbs={[{ label: t('pages.kpis.crumb') }]}
        actions={
          <>
            <span className="header-period">
              <FaCalendarAlt /> {months[month - 1]} {year}
            </span>
            <Form.Group controlId="selYear" className="period-select">
              <Form.Label>{t('kpis.year')}</Form.Label>
              <Form.Control
                as="select"
                value={year}
                onChange={e => { setYear(+(e.target.value)); }}
              >
                {years.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="selMonth" className="period-select">
              <Form.Label>{t('kpis.month')}</Form.Label>
              <Form.Control
                as="select"
                value={month}
                onChange={e => { setMonth(+(e.target.value)); }}
              >
                {months.map((item, i) => (
                  <option key={i + 1} value={i + 1}>{item}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </>
        }
      />

      <div className="kpi-summary">
        <KpiStat label={t('kpis.serviceCalls')} value={createdTotal} hint={t('kpis.pendingHint', { count: pendingTotal })} />
        <KpiStat
          label={t('common.completed')}
          value={completedTotal}
          hint={completionRate === null ? t('kpis.noCreated') : t('kpis.ofCreated', { pct: formatPct(completionRate) })}
          tone={completionRate === null ? 'neutral' : completionRate >= 90 ? 'good' : completionRate >= 70 ? 'warn' : 'bad'}
        />
        <KpiStat
          label={t('kpis.slaAttendance')}
          value={formatPct(slaAttendRate)}
          hint={slaAttendOk + slaAttendLate ? t('kpis.slaOnTimeHint', { ok: slaAttendOk, total: slaAttendOk + slaAttendLate }) : t('kpis.noSla')}
          tone={slaTone(slaAttendRate)}
        />
        <KpiStat
          label={t('kpis.slaCompletion')}
          value={formatPct(slaRepairRate)}
          hint={slaRepairOk + slaRepairLate ? t('kpis.slaOnTimeHint', { ok: slaRepairOk, total: slaRepairOk + slaRepairLate }) : t('kpis.noSla')}
          tone={slaTone(slaRepairRate)}
        />
        <KpiStat label={t('kpis.annualSpend')} value={formatEuro(totalCosts, true)} hint={t('kpis.yearToDate', { year })} />
      </div>

    <section className="kpi-section">
      <h2>{t('kpis.serviceCalls')}</h2>
      <div className="row kpi-grid">
      <div className="col-lg-8 col-md-12 kpi-col">
        <Graph
          title={t('kpis.createdVsCompleted')}
          subtitle={`${months[month - 1]} ${year}`}
          type="bar"
          data={serviceCall}
          options={barOptions}
        />
      </div>
      <div className="col-lg-4 col-md-12 kpi-col">
        <Card className="legend-card">
            <Card.Header className="legend-card-header">
              <div className="legend-header-row">
                <span className="legend-col-type">{t('common.type')}</span>
                <span className="legend-col-num">{t('kpis.created')}</span>
                <span className="legend-col-num">{t('kpis.done')}</span>
                <span className="legend-col-num">{t('kpis.pending')}</span>
              </div>
            </Card.Header>
            <Card.Body className="legend-body">
              {servCallTbl.map((item) => (
                <div key={item.key} className="legend-row">
                  <span className="legend-col-type">{tCatalog(item.key)}</span>
                  <span className="legend-col-num">{item.created}</span>
                  <span className="legend-col-num">{item.completed}</span>
                  <span className="legend-col-num">{item.pending}</span>
                </div>
              ))}
              <div className="legend-row legend-total">
                <span className="legend-col-type">{t('common.total')}</span>
                <span className="legend-col-num">{createdTotal}</span>
                <span className="legend-col-num">{completedTotal}</span>
                <span className="legend-col-num">{pendingTotal}</span>
              </div>
            </Card.Body>
        </Card>
      </div>
      </div>
    </section>

    <section className="kpi-section">
      <h2>{t('kpis.maintenance')}</h2>
      <p className="kpi-section-note">{t('kpis.maintenanceNote', { reactive: reactiveCreated, created: ppmCreated, completed: ppmCompleted, pending: ppmPending })}</p>
      <div className="row kpi-grid">
      <div className="col-lg-8 col-md-12 kpi-col">
        <Graph
          title={t('kpis.reactiveByFault')}
          subtitle={t('kpis.sortedByVolume')}
          type="horizontalBar"
          data={reactiveData}
          options={horizOptions}
        />
      </div>
      <div className="col-lg-4 col-md-12 kpi-col">
        <Card className="legend-card">
            <Card.Header className="legend-card-header">
              <div className="legend-header-row">
                <span className="legend-col-type">{t('kpis.fault')}</span>
                <span className="legend-col-num">{t('kpis.created')}</span>
                <span className="legend-col-num">{t('kpis.done')}</span>
                <span className="legend-col-num">{t('kpis.pending')}</span>
              </div>
            </Card.Header>
            <Card.Body className="legend-body">
              {reactiveTbl.map((item) => (
                <div key={item.key} className="legend-row">
                  <span className="legend-col-type" title={tCatalog(item.key)}>{tCatalog(item.key)}</span>
                  <span className="legend-col-num">{item.created}</span>
                  <span className="legend-col-num">{item.completed}</span>
                  <span className="legend-col-num">{item.pending}</span>
                </div>
              ))}
            </Card.Body>
        </Card>
      </div>
      <div className="col-lg-8 col-md-12 kpi-col">
        <Graph
          title={t('kpis.preventative')}
          subtitle={t('kpis.inspectionsRoutine')}
          type="horizontalBar"
          data={ppmData}
          options={horizOptions}
        />
      </div>
      <div className="col-lg-4 col-md-12 kpi-col">
        <Card className="legend-card">
            <Card.Header className="legend-card-header">
              <div className="legend-header-row">
                <span className="legend-col-type">{t('common.type')}</span>
                <span className="legend-col-num">{t('kpis.created')}</span>
                <span className="legend-col-num">{t('kpis.done')}</span>
                <span className="legend-col-num">{t('kpis.pending')}</span>
              </div>
            </Card.Header>
            <Card.Body className="legend-body">
              {ppmTbl.map((item) => (
                <div key={item.key} className="legend-row">
                  <span className="legend-col-type" title={tCatalog(item.key)}>{tCatalog(item.key)}</span>
                  <span className="legend-col-num">{item.created}</span>
                  <span className="legend-col-num">{item.completed}</span>
                  <span className="legend-col-num">{item.pending}</span>
                </div>
              ))}
            </Card.Body>
        </Card>
      </div>
      </div>
    </section>

    <section className="kpi-section">
      <h2>{t('kpis.slaPerformance')}</h2>
      <p className="kpi-section-note">{t('kpis.slaNote', { month: months[month - 1] })}</p>
      <div className="row kpi-grid">
      <div className="col-lg-8 col-md-12 kpi-col">
        <Graph
          title={t('kpis.slaAttendance')}
          subtitle={formatPct(slaAttendRate)}
          type="horizontalBar"
          data={slaAttendanceData}
          options={slaHorizOptions}
        />
      </div>
      <div className="col-lg-4 col-md-12 kpi-col">
        <Card className="legend-card">
            <Card.Header className="legend-card-header">
              <div className="legend-header-row">
                <span className="legend-col-type">{t('common.type')}</span>
                <span className="legend-col-num">{t('kpis.onTime')}</span>
                <span className="legend-col-num">{t('kpis.late')}</span>
                <span className="legend-col-num">{t('kpis.rate')}</span>
              </div>
            </Card.Header>
            <Card.Body className="legend-body">
              {slaAttendanceTbl.map((item) => (
                <div key={item.key} className="legend-row">
                  <span className="legend-col-type">{tCatalog(item.key)}</span>
                  <span className="legend-col-num">{item.compl}</span>
                  <span className="legend-col-num">{item.noncomp}</span>
                  <span className={`legend-col-num is-${slaTone(item.rate)}`}>{formatPct(item.rate)}</span>
                </div>
              ))}
              <div className="legend-row legend-total">
                <span className="legend-col-type">{t('common.total')}</span>
                <span className="legend-col-num">{slaAttendOk}</span>
                <span className="legend-col-num">{slaAttendLate}</span>
                <span className={`legend-col-num is-${slaTone(slaAttendRate)}`}>{formatPct(slaAttendRate)}</span>
              </div>
            </Card.Body>
        </Card>
      </div>
      <div className="col-lg-8 col-md-12 kpi-col">
        <Graph
          title={t('kpis.slaCompletion')}
          subtitle={formatPct(slaRepairRate)}
          type="horizontalBar"
          data={slaRepairData}
          options={slaHorizOptions}
        />
      </div>
      <div className="col-lg-4 col-md-12 kpi-col">
        <Card className="legend-card">
            <Card.Header className="legend-card-header">
              <div className="legend-header-row">
                <span className="legend-col-type">{t('common.type')}</span>
                <span className="legend-col-num">{t('kpis.onTime')}</span>
                <span className="legend-col-num">{t('kpis.late')}</span>
                <span className="legend-col-num">{t('kpis.rate')}</span>
              </div>
            </Card.Header>
            <Card.Body className="legend-body">
              {slaRepairTbl.map((item) => (
                <div key={item.key} className="legend-row">
                  <span className="legend-col-type">{tCatalog(item.key)}</span>
                  <span className="legend-col-num">{item.compl}</span>
                  <span className="legend-col-num">{item.noncomp}</span>
                  <span className={`legend-col-num is-${slaTone(item.rate)}`}>{formatPct(item.rate)}</span>
                </div>
              ))}
              <div className="legend-row legend-total">
                <span className="legend-col-type">{t('common.total')}</span>
                <span className="legend-col-num">{slaRepairOk}</span>
                <span className="legend-col-num">{slaRepairLate}</span>
                <span className={`legend-col-num is-${slaTone(slaRepairRate)}`}>{formatPct(slaRepairRate)}</span>
              </div>
            </Card.Body>
        </Card>
      </div>
      </div>
    </section>

    <section className="kpi-section">
      <h2>{t('kpis.annualSpend')}</h2>
      <div className="row kpi-grid">
      <div className="col-lg-5 col-md-12 kpi-col">
        <Graph
          title={t('kpis.spendTitle', { year })}
          subtitle={formatEuro(totalCosts)}
          type="doughnut"
          data={spendData}
          options={doughnutOptions}
        />
      </div>
      <div className="col-lg-7 col-md-12 kpi-col">
        <Card className="legend-card costs-card">
            <Card.Header className="legend-card-header costs-header">
              <span>{t('kpis.breakdown')}</span>
              <span className="costs-total">{formatEuro(totalCosts)}</span>
            </Card.Header>
            <Card.Body className="legend-body costs-body">
              {dataCosts.map((item) => (
                <div key={item.key} className="legend-row">
                  <span className="legend-col-type">
                    <span className="spend-dot" style={{ background: item.color }} />
                    {tCatalog(item.key)}
                  </span>
                  <span className="legend-col-value">{formatEuro(item.value)}</span>
                </div>
              ))}
            </Card.Body>
        </Card>
      </div>
      </div>
    </section>
  </div>
    
  );
}

export default KPIs;
